import { getLocaleISOString } from './getLocaleISOString';

export default function mapFieldsToState(fields, query = {}, countryCode, draftCheckout = null) {
  if (!fields || !fields.length) return {};

  const fieldsFormFields = fields.reduce((obj, item) => {
    const defaultValue = item.defaultValue?.enabled ? item.defaultValue.value : '';

    if (item.element === 'country') {
      obj[item._id] = {
        ...item,
        value: defaultValue || countryCode || 'US',
      };
      return obj;
    }

    if (item.element === 'checkbox') {
      if (defaultValue === 'true') {
        obj[item._id] = { ...item, value: true };
      } else if (defaultValue === 'false') {
        obj[item._id] = { ...item, value: false };
      } else {
        obj[item._id] = { ...item, value: defaultValue || false };
      }
      return obj;
    }

    if (item.element === 'quantity') {
      obj[item._id] = { ...item, value: Number(defaultValue) || 1 };
      return obj;
    }

    obj[item._id] = { ...item, value: defaultValue };
    return obj;
  }, {});

  // Pre-populate from draft checkout data if available
  if (draftCheckout?.fields) {
    draftCheckout.fields.forEach(draftField => {
      /**
       * It is possible for a page to delete a field that existed in a draft checkout.
       * Filter out any null fields to avoid errors.
       */
      if (draftField.fieldId == null) {
        return;
      }

      // Handle both object and ID formats for fieldId
      const fieldId = draftField.fieldId?._id != null ? draftField.fieldId._id : draftField.fieldId;

      const field = Object.values(fieldsFormFields).find(field => field._id === fieldId);

      if (field && draftField.value !== undefined && draftField.value !== null) {
        if (field.element === 'checkbox') {
          fieldsFormFields[field._id].value =
            draftField.value === 'true' || draftField.value === true;
        } else if (field.element === 'quantity') {
          fieldsFormFields[field._id].value = Number(draftField.value) || 1;
        } else if (field.element === 'date-time') {
          fieldsFormFields[field._id].value =
            getLocaleISOString(draftField.value) || draftField.value;
        } else if (field.element === 'date') {
          fieldsFormFields[field._id].value =
            getLocaleISOString(draftField.value)?.split('T')?.[0] || draftField.value;
        } else if (field.element === 'phone') {
          // For phone fields, store the value as-is since it's already in proper format from draft
          fieldsFormFields[field._id].value = draftField.value;
        } else {
          fieldsFormFields[field._id].value = draftField.value;
        }
      }
    });
  }

  // match params to form field references (query params override draft data)
  Object.entries(query).forEach(([key, value]) => {
    const field = Object.values(fieldsFormFields).find(field => field.reference === key);

    if (field) {
      // For phone fields, properly decode the URL component
      if (field.element === 'phone') {
        fieldsFormFields[field._id].value = decodeURIComponent(value.replace(/\s/g, '+'));
      } else if (field.element === 'date-time') {
        fieldsFormFields[field._id].value = getLocaleISOString(value) || value;
      } else if (field.element === 'date') {
        fieldsFormFields[field._id].value = getLocaleISOString(value)?.split('T')?.[0] || value;
      } else {
        fieldsFormFields[field._id].value = value;
      }
    }
  });

  return fieldsFormFields;
}
